import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { Wishlist } from '../../models'

export const MB_WISHLIST_NORMALIZER = new InjectionToken<Converter<any, Wishlist>>('MbWishlistNormalizer')
